import { File, FileArchive, FileAudio, FileImage, FileText, FileVideo, FileCode, FileSpreadsheet } from "lucide-react";

export function iconFor(mime = "", ext = "") {
  if (mime.startsWith("image/")) return FileImage;
  if (mime.startsWith("video/")) return FileVideo;
  if (mime.startsWith("audio/")) return FileAudio;
  if (["zip", "rar", "7z", "gz", "tar"].includes(ext)) return FileArchive;
  if (["xls", "xlsx", "csv"].includes(ext)) return FileSpreadsheet;
  if (["json", "xml", "js", "html", "css", "py"].includes(ext)) return FileCode;
  if (mime.startsWith("text/") || ["pdf", "doc", "docx", "md"].includes(ext)) return FileText;
  return File;
}

export function FileIcon({ mime, ext, className = "h-6 w-6" }) {
  const Icon = iconFor(mime, ext);
  return <Icon className={className} aria-hidden="true" />;
}
